/**
 * Get user selected choices for a question, handling correct/incorrect/random logic.
 * @param {Object} params
 * @param {Object} params.question - The question object
 * @param {Object} params.stat - The statistics/state object for the question
 * @param {Object} params.config - Config object for question type specifics
 * @returns {Object} { selectedOptions, extraState } - State to set in the component
 */
export function getUserSelectedChoices({ question, stat, config = {} }) {
  try {
    // 1. If user has selected choices, parse and return
    if (stat && stat.selected_choice) {
      const { selected_choice } = stat;
      const { extractExtraState } = config;
      const selectedOptions = JSON.parse(selected_choice);
      return {
        selectedOptions,
        extraState:
          typeof extractExtraState === 'function' ? extractExtraState(selectedOptions, stat) : {},
      };
    }

    // 2. If correct answer to be filled in
    if (stat && stat.answer === 1) {
      const { getCorrectOptions, extractExtraState } = config;
      if (getCorrectOptions) {
        const selectedOptions = getCorrectOptions(question);
        return {
          selectedOptions,
          extraState:
            typeof extractExtraState === 'function' ? extractExtraState(selectedOptions, stat) : {},
        };
      }
    }

    // 3. If incorrect answer to be filled randomly
    if (stat && stat.answer === 0) {
      const { getWrongOptions, extractExtraState } = config;
      if (getWrongOptions) {
        const selectedOptions = getWrongOptions(question);
        return {
          selectedOptions,
          extraState:
            typeof extractExtraState === 'function' ? extractExtraState(selectedOptions, stat) : {},
        };
      }
    }
  } catch (err) {
    // Swallow error silently to avoid linter issues
  }
  // Default: return empty
  return { selectedOptions: {}, extraState: {} };
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/Quiz/utils/quizUtils.js